import { motion } from "framer-motion";
import Typewriter from "typewriter-effect";
import { FiDownload } from "react-icons/fi";
import SocialIcons from "./SocialIcons";
import Button from "./Button";
import profile from "../_data/profile.json";
import { useCopy } from "../i18n/useCopy";

/**
 * Represents the hero section of the page.
 *
 * @component
 */

const Hero = () => {
  const t = useCopy();
  return (
    <section className="hero" aria-labelledby="hero-title">
      {/* Background portrait */}
      <motion.picture
        className="heroImage"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 1.2, ease: "easeInOut" }}
      >
        <img
          src="/images/khachik-harutyunyan-mountains.webp"
          alt={t.hero.imageAlt}
          width="895"
          height="1200"
          fetchpriority="high"
        />
      </motion.picture>

      <div className="heroContent">

        <motion.p
          className="eyebrow"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.1, duration: 0.5 }}
        >
          {t.hero.eyebrow}
        </motion.p>

        {/* Name — the page's single h1 */}
        <motion.h1
          id="hero-title"
          className="name"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.15, duration: 0.5, type: "spring" }}
        >
          {t.name}
        </motion.h1>

        <motion.h2
          className="heroTitle"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          {t.title}
        </motion.h2>

        {/* Rotating value propositions */}
        <div className="description" aria-live="off">
          <Typewriter
            key={t.lang}
            options={{
              strings: t.typewriter,
              autoStart: true,
              loop: true,
              delay: 40,
              deleteSpeed: 20,
              pauseFor: 2200,
            }}
          />
        </div>

        <motion.div
          className="heroCtas"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
        >
          <Button name={t.hero.hire} to="/contact" />
          <Button
            name={t.hero.cv}
            href={profile.cv.pdf}
            download
            variant="ghost"
            icon={<FiDownload className="arrow-icon" aria-hidden="true" />}
          />
        </motion.div>

        <motion.ul
          className="heroStack"
          aria-label={t.hero.stackLabel}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7, duration: 0.6 }}
        >
          {profile.coreStack.map((tech) => (
            <li key={tech}>{tech}</li>
          ))}
        </motion.ul>
      </div>

      <div className="heroSocials">
        <SocialIcons />
      </div>
    </section>
  );
};

export default Hero;
